import React from 'react';
import { EdgeProps, getBezierPath, EdgeLabelRenderer, BaseEdge } from 'reactflow';
import s from '../../s.module.less';

interface IConditionEdgeData {
    condition?: string;
    label?: string;
}

const ConditionEdge: React.FC<EdgeProps<IConditionEdgeData>> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data,
    selected,
}) => {
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                style={{
                    stroke: selected ? '#1890ff' : '#1890ff',
                    strokeWidth: selected ? 3 : 2,
                }}
            />
            <EdgeLabelRenderer>
                <div
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                        fontSize: 12,
                        pointerEvents: 'all',
                    }}
                    className={s.edgeLabel}
                >
                    {data?.label || data?.condition || 'Condition'}
                </div>
            </EdgeLabelRenderer>
        </>
    );
};

export default ConditionEdge;
